import { render, staticRenderFns } from "./PostSchool.vue?vue&type=template&id=68dc1f89&scoped=true"
import script from "./PostSchool.vue?vue&type=script&lang=js"
export * from "./PostSchool.vue?vue&type=script&lang=js"
import style0 from "./PostSchool.vue?vue&type=style&index=0&id=68dc1f89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dc1f89",
  null
  
)

export default component.exports